import request from 'superagent'
import { lockButton, unlockButton } from 'src/lockButton'
import { handleErrors } from 'src/errors'

function userFunctions() {
  $('#offcanvasRight').on('click', '#deleteUser', function(event) {
    lockButton('#deleteUser')

    const id = $("#basic-information").find('form').attr('action').split('/').pop()

    request.get('/delete_user_data?id=' + id)
      .set('X-CSRF-Token', $('meta[name="csrf-token"]').attr('content'))
      .accept('json')
      .then(res => {
        let select = ''
        if (res.body.users) {
          select = '<br><br>' + I18n.t("delete_user_modal.transfers_customers") + ' <select id="transferCustomers" class="form-select">'
          let selected = false
          for(let i in res.body.users) {
            let setSelected = ''
            if (!selected && res.body.bu !== null && res.body.users[i].business_unit_ids !== null) {
              if (res.body.users[i].business_unit_ids.includes(res.body.bu.id)) {
                setSelected = ' selected="selected"'
                selected = true
              }
            }
            let name = res.body.users[i].first_name + ' ' + res.body.users[i].last_name
            select += '<option' + setSelected + ' value="' + res.body.users[i].id + '">' + name + '</option>'
          }
          select += '</select>'

          select += '<br>' + I18n.t("delete_user_modal.transfer_events") + ' <select id="transferEvents" class="form-select">'
          selected = false
          for(let i in res.body.users) {
            let setSelected = ''
            if (!selected && res.body.bu !== null && res.body.users[i].business_unit_ids !== null) {
              if (res.body.users[i].business_unit_ids.includes(res.body.bu.id)) {
                setSelected = ' selected="selected"'
                selected = true
              }
            }
            let name = res.body.users[i].first_name + ' ' + res.body.users[i].last_name
            select += '<option' + setSelected + ' value="' + res.body.users[i].id + '">' + name + '</option>'
          }
          select += '</select>'
        }

        $("#mainModal").html('<div class="modal-dialog"><div class="modal-content"><div class="modal-header text-center"><h4 class="modal-title w-100 font-weight-bold">' + I18n.t("delete_modal.title") + '</h4><button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button></div><div class="modal-body">' + I18n.t("delete_modal.body") + select + '</div><div class="modal-footer"><button id="confirmDelete" type="button" class="btn btn-danger" data-id="' + id + '"><i class="bi bi-trash"></i> ' + I18n.t("buttons.delete") + '</button></div></div></div>')
          mainModal.show()

          unlockButton('#deleteUser')
      })
      .catch(err => {
        handleErrors(err, '#deleteUser')
      })
  })

  $('#offcanvasRight').on('change', '#user_role', function(event) {
    if ($(this).val() != 'MYYJÄ') {
      $('#user_country').prop("disabled", true)
      $('#user_client_company_id').prop("disabled", true)
    } else {
      $('#user_country').prop("disabled", false)
      $('#user_client_company_id').prop("disabled", false)
    }

    if (['ADMIN', 'PP', 'PEM', 'PO'].includes($(this).val())) {
      $('#user_business_unit_ids').prop("disabled", false)
    } else {
      $('#user_business_unit_ids').prop("disabled", true)
    }
  })

  $('#offcanvasRight').on('change', '#user_country', function(event) {
    $.getScript('/clients/' + $('#user_client_id').val() + '/client_companies?country=' + $(this).val())
  })
}

export { userFunctions }
